<script setup lang="ts">
</script>

<template>
    <div class="col items-center justify-center size-full gap-6 p-10 text-center">
        <h1 class="text-2xl font-bold text-blue">
            Sei stato eliminato per inattività
        </h1>
        <p class="text-sm text-gray-dark max-w-175">
            Sei rimasto inattivo troppo a lungo e sei stato escluso definitivamente dallo studio.
            Non è possibile rientrare nella sessione.
        </p>
    </div>
</template>

<style scoped>
</style>
